export let reactProjects = [
    {
        title: "Shopping List",
        link: "https://github.com/VocalNight/ShoppingListReact",
        description: "Small project in react to practice tables, database with back-end in C# and a bit of front end."
    },
    {
        title: "Friends Manager",
        link: "https://github.com/VocalNight/FriendContact",
        description: "Project made with tailwind for practice, also experimented with Redux."
    },
     {
        title: "Crud project",
        link: "https://github.com/VocalNight/Crud-React",
        description: "Project made with tailwind and react. Backend in C#. It's generic so far and needs more tests."
     },
    
]
